import styles from './chip-badge.module.css'

/**
 * Las dos variantes del chip, y su clase.
 *
 * Vive junto a `chip-badge.module.css` por lo mismo que `tones.ts`: el CSS declara las clases y
 * esto dice cómo se piden. Y por una razón de más — `chip.tsx` exporta componentes, y una constante
 * al lado le rompe el fast-refresh (`react-refresh/only-export-components`). La regla de ESLint
 * pide exactamente esto: un archivo aparte para lo que comparten dos componentes, que acá son el
 * `Chip` y el `ChipButton`.
 *
 * **Son dos, no cuatro.** `outline` y `solid` salieron del eje: los dos pesos que quedan son los
 * dos que un chip necesita —el fondo teñido pelado y el mismo con su borde—, y son los que las
 * páginas usaban. Un chip aparece de a varios y a esa densidad un contorno pelado o un relleno
 * lleno compiten con el contenido; para eso está el botón, que sí conserva las cuatro formas.
 */
export type ChipVariant = 'subtle' | 'soft'

export const CHIP_VARIANT_CLASS: Record<ChipVariant, string> = {
  subtle: styles['au-chip--subtle'],
  soft: styles['au-chip--soft'],
}
